var Extras = /** @class */ (function () {
    function Extras() {
        this.checked = false;
        this.errorMsg = {};
        this.validation = {};
    }
    return Extras;
}());
export default Extras;
